import { Component } from '@angular/core';
import { LAYOUT_TYPE } from '../../model/common.model';
import { PageContainerComponent } from "../../layout/page-container/page-container.component";
import { DynamicFormArray, Props,  TabConfig } from '../../model/form.model';
import { AseLexusProps,AseLexusTitle, AseLexusDashboardTabConfig } from '../../model/ase-lexus.model';
import { CommonModule } from '@angular/common';
import { AseCerStatusFormArray } from '../../model/ase-crt-status.model';

@Component({
  selector: 'app-ase-lexus',
  standalone: true,
  imports: [PageContainerComponent,CommonModule],
  templateUrl: './ase-lexus.component.html',
  styleUrl: './ase-lexus.component.scss'
})
export class AseLexusComponent {
  title = AseLexusTitle;
  DataTableSchema:any;
  readonly LayoutType: typeof LAYOUT_TYPE = LAYOUT_TYPE;
  tabConfig: Array<TabConfig> = AseLexusDashboardTabConfig;
  dynamicFormArray: DynamicFormArray =AseCerStatusFormArray;
  props: Props = AseLexusProps;
}